import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';
import './form-item-fleet-management-report-lost-stolen-card.component.scss';
var FormItemFleetManagementReportLostStolenCard = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemFleetManagementReportLostStolenCard, _super);
    function FormItemFleetManagementReportLostStolenCard(element) {
        var _this = _super.call(this, element) || this;
        _this.newCardRequiredVal = '';
        _this.otherItemsLostStolenVal = '';
        _this.lossTheftReportedVal = '';
        _this.emailAddress = [
            {
                name: "Western_Cape",
                email: "enterprisedirect.westerncape@standardbank.co.za"
            }, {
                name: "Mpumalanga",
                email: "enterprisemp@standardbank.co.za"
            }, {
                name: "Eastern_Cape",
                email: "enterprisedirect.easterncape@standardbank.co.za "
            }, {
                name: "North_West",
                email: "directcst.northwest@standardbank.co.za"
            }, {
                name: "Free_State",
                email: "enterprisedirectfsnc@standardbank.co.za"
            }, {
                name: "Kwa_Zulu_Natal",
                email: "directlifestylesupportkzn@standardbank.co.za "
            }, {
                name: "Limpopo",
                email: "enterpriselp@standardbank.co.za"
            }, {
                name: "Northern_Cape",
                email: "enterprisedirectfsnc@standardbank.co.za"
            }, {
                name: "Ekurhuleni",
                email: "ekurhuleni.businessbanking@standardbank.co.za"
            }, {
                name: "CityOfJohannesburg",
                email: "COJ.businessbanking@standardbank.co.za"
            }, {
                name: "CityOfTshwane",
                email: "tshwane.businessbanking@standardbank.co.za"
            }, {
                name: "MetswedingDistrict",
                email: "tshwane.businessbanking@standardbank.co.za"
            }, {
                name: "SedibengDistrict",
                email: "ekurhuleni.businessbanking@standardbank.co.za"
            }, {
                name: "WestRandDistrict",
                email: "coj.businessbanking@standardbank.co.za "
            }
        ];
        return _this;
    }
    FormItemFleetManagementReportLostStolenCard.prototype.init = function () {
        // form
        this.form = this.element.querySelector('form');
        this.submitBtn = Array.from(this.element.querySelectorAll('.js-reportCardLostStolen__button--submit'));
        this.closeButton = this.element.querySelector('.js-apply-now-modal-close');
        this.activeModal = this.element.querySelector('#form-item-fleet-management-report-lost-stolen-card');
        this.buttonNextStep1 = this.element.querySelector('.next-button-1');
        this.buttonNextStep2 = this.element.querySelector('.next-button-2');
        this.buttonNextStep3 = this.element.querySelector('.next-button-3');
        this.buttonNextStep4 = this.element.querySelector('.submit-button');
        //Personal Details Init
        this.customerNumber = this.element.querySelector("input[name=customer-number]");
        this.customerName = this.element.querySelector("input[name=customer-name]");
        this.registrationNumber = this.element.querySelector("input[name=registration-number]");
        this.vehicleDescription = this.element.querySelector("input[name=vehicle-description]");
        this.lostStolenCardNumber = this.element.querySelector("input[name=lost-stolen-card-number]");
        //Card Details Init
        this.personName = this.element.querySelector("input[name=person-name]");
        this.businessAddress = this.element.querySelector("input[name-business-address]");
        this.residentialAddress = this.element.querySelector("input[name=residential-address]");
        this.workTelNumber = this.element.querySelector("input[name=work-tel-number]");
        this.homeTelNumber = this.element.querySelector("input[name=home-tel-number]");
        this.dateCardLost = this.element.querySelector("input[name=date-card-lost-stolen]");
        //Reporting Init
        this.whereLossTheftOccured = this.element.querySelector("input[name=where-loss-theft-occured]");
        console.log("anything", this.whereLossTheftOccured);
        this.newCardRequiredCont = this.element.querySelector(".js-new-card-required-container"); //radio group
        this.newCardRequiredCont.querySelectorAll('input[name=new-card-required]').forEach(function (el) {
            el.classList.add("js-new-card-required_radio--group");
        });
        this.newCardRequiredFields = Array.from(this.element.querySelectorAll('.js-new-card-required_radio--group'));
        //this.newCardRequired = this.element.querySelector('input[name=new-card-required]')
        this.otherItemsLostStolenCont = this.element.querySelector(".js-other-items-lost-stolen-container"); //radio group
        this.otherItemsLostStolenCont.querySelectorAll('input[name=other-items-lost-stolen]').forEach(function (el) {
            el.classList.add('js-other-items-lost-stolen_radio--group');
        });
        this.otherItemsLostFields = Array.from(this.element.querySelectorAll('.js-other-items-lost-stolen_radio--group'));
        //this.otherItemsLostStolen = this.element.querySelector(`input[name=other-items-lost-stolen]`);
        this.itemsLostStolen = this.element.querySelector("input[name=items-lost-stolen]");
        this.itemsLostStolenCont = this.element.querySelector(".js-items-lost-stolen-container");
        this.lossTheftReportedCont = this.element.querySelector(".js-has-loss-theft-reported-container"); //radio group
        this.lossTheftReportedCont.querySelectorAll('input[name=has-loss-theft-reported]').forEach(function (el) {
            el.classList.add('js-loss-theft-reported_radio--group');
        });
        this.lossTheftReportedFields = Array.from(this.element.querySelectorAll('.js-loss-theft-reported_radio--group'));
        //this.lossTheftReported =  this.element.querySelector('input[name=has-loss-theft-reported]');
        this.dateReported = this.element.querySelector("input[name=date-reported]");
        this.dateReportedCont = this.element.querySelector(".js-date-reported-container");
        this.nameOfPoliceStation = this.element.querySelector("input[name=name-of-police-station]");
        this.nameOfPoliceStationCont = this.element.querySelector(".js-name-of-police-station-container");
        this.caseNumber = this.element.querySelector("input[name=case-number]");
        this.caseNumberCont = this.element.querySelector(".js-case-number-container");
        //Declaration Init
        this.declarationName = this.element.querySelector("input[name=declaration-name]");
        this.servicetype = "fleetManagementReportLostStolenCard";
        this.declarationDate = this.element.querySelector("input[name=declaration-date]");
        this.declarationDateCont = this.element.querySelector(".js-declaration-date-container");
        this.declarationTime = this.element.querySelector("select[name=declaration-time]");
        this.declarationDA1 = this.element.querySelector("input[name=declaration-DA1]");
        this.declarationDA2 = this.element.querySelector("input[name=declaration-DA2]");
        this.declarationDA3 = this.element.querySelector("input[name=declaration-DA3]");
        var newTime = Date.now();
        //this.declarationTime.innerHTML = newTime.toString();
        //Container init
        this.dateCardLostStolenCont = this.element.querySelector('.js-date-card-lost-stolen-container');
        // this.applyFormRadio = Array.from(this.element.querySelectorAll('.js-identification_radio--group'));
        this.wizard = this.element.querySelector('.form-container-wizard__wizard');
        var formModal = this.element.closest(".modal").querySelector(".modal__dialog--small");
        formModal.classList.remove('modal__dialog--small');
        formModal.classList.add('modal__dialog--large');
        // buttons
        this.submitBtn = Array.from(this.element.querySelectorAll('.js-reportCardLostStolen__button--submit'));
    };
    FormItemFleetManagementReportLostStolenCard.prototype.getDateReported = function (form) {
        var dcls = form.querySelector('input[name=date-reported]');
        var dateSections = dcls.value.split('/');
        if (dateSections.length > 0 && dateSections.length <= 3) {
            this.dateValid = this.validateDateCardReported(dcls.value);
        }
        return this.dateValid;
    };
    FormItemFleetManagementReportLostStolenCard.prototype.getDateCardLost = function (form) {
        var dcls = form.querySelector('input[name=date-card-lost-stolen]');
        var dateSections = dcls.value.split('/');
        if (dateSections.length > 0 && dateSections.length <= 3) {
            this.dateValid = this.validateDateCardLostStolen(dcls.value);
        }
        return this.dateValid;
    };
    FormItemFleetManagementReportLostStolenCard.prototype.bindEvents = function () {
        var _this = this;
        this.newCardRequiredFields.map(function (item) { return item.addEventListener('click', function (event) {
            var evt = event.target;
            _this.newCardRequired = evt.value;
            console.log("req:", _this.newCardRequired);
            _this.newCardRequiredVal = _this.newCardRequired;
        }); });
        this.otherItemsLostFields.map(function (item) { return item.addEventListener('click', function (event) {
            var evt = event.target;
            _this.anyItemLostStolen = evt.value;
            console.log("items:", _this.anyItemLostStolen);
            _this.otherItemsLostStolenVal = _this.anyItemLostStolen;
            if (_this.anyItemLostStolen === "YES") {
                _this.itemsLostStolenCont.classList.remove('form__group--hidden');
            }
            else {
                _this.itemsLostStolenCont.classList.add('form__group--hidden');
            }
        }); });
        if (this.buttonNextStep2) {
            this.buttonNextStep2.addEventListener("click", function (event) {
                if (!_this.getDateCardLost(_this.form)) {
                    event.stopImmediatePropagation(); // stop from going to next step
                }
            });
        }
        if (this.buttonNextStep3) {
            this.buttonNextStep3.addEventListener("click", function (event) {
                if (!_this.validateNewCardRequired()) {
                    event.stopImmediatePropagation();
                }
                if (!_this.validateOtherItemsLostStolen()) {
                    event.stopImmediatePropagation();
                }
                if (!_this.validateCardReported()) {
                    event.stopImmediatePropagation();
                }
                if (!_this.getDateReported(_this.form)) {
                    event.stopImmediatePropagation();
                }
            });
        }
        this.lossTheftReportedFields.map(function (item) { return item.addEventListener('click', function (event) {
            var evt = event.target;
            _this.hasTheftLossReported = evt.value;
            console.log("theft:", _this.hasTheftLossReported);
            _this.lossTheftReportedVal = _this.hasTheftLossReported;
            if (_this.hasTheftLossReported === "YES") {
                _this.dateReportedCont.classList.remove('form__group--hidden');
                _this.nameOfPoliceStationCont.classList.remove('form__group--hidden');
                _this.caseNumberCont.classList.remove('form__group--hidden');
            }
            else {
                _this.dateReportedCont.classList.add('form__group--hidden');
                _this.nameOfPoliceStationCont.classList.add('form__group--hidden');
                _this.caseNumberCont.classList.add('form__group--hidden');
            }
        }); });
        this.submitBtn.map(function (item) { return item.addEventListener('click', function (event) {
            var _button = event.target;
            var _form = _button.closest('form');
            var formFields = _form.querySelectorAll('input, select');
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll('.form__group--error'));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        }); });
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll('input, select, textarea, radio, text'));
            if (_formFields) {
                _formFields.forEach(function (pElement) {
                    pElement.addEventListener('blur', function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        // Reset the form
        this.form.addEventListener('custom_form_reset_event', function (e) {
            if (_this.wizard) {
                var event_1 = new CustomEvent('custom_wizard_reset_event');
                _this.wizard.dispatchEvent(event_1);
            }
        }, false);
    };
    FormItemFleetManagementReportLostStolenCard.prototype.validateDateCardLostStolen = function (value) {
        var selectionArray = [];
        var dateOfCardLostStolenErrorDetails = "Date can\u2019t be in the future.";
        var isValid = true;
        var datePassed = new Date(value);
        var todaysDate = new Date();
        var _dateCardLost = this.dateCardLost.closest(".form__group");
        selectionArray.push(_dateCardLost);
        // Clear errors
        selectionArray.forEach(function (groupItem) {
            groupItem.classList.remove('form__group--error');
            var errorMessage = groupItem.querySelector('.form__group--error_message');
            if (errorMessage) {
                errorMessage.remove();
            }
        });
        if (!_dateCardLost.classList.contains("form__group--hidden")) {
            if (datePassed > todaysDate) {
                isValid = false;
                this.dateCardLostStolenCont.classList.add("form__group--error");
                _dateCardLost.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = dateOfCardLostStolenErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                this.dateCardLostStolenCont.appendChild(_errorDiv);
            }
        }
        return isValid;
    };
    FormItemFleetManagementReportLostStolenCard.prototype.validateDateCardReported = function (value) {
        var selectionArray = [];
        var dateCardReportedError = "Date can\u2019t be in the future.";
        var isValid = true;
        var datePassed = new Date(value);
        var todaysDate = new Date();
        var _dateCardReported = this.dateReported.closest(".form__group");
        selectionArray.push(_dateCardReported);
        // Clear errors
        selectionArray.forEach(function (groupItem) {
            groupItem.classList.remove('form__group--error');
            var errorMessage = groupItem.querySelector('.form__group--error_message');
            if (errorMessage) {
                errorMessage.remove();
            }
        });
        if (!_dateCardReported.classList.contains("form__group--hidden")) {
            if (datePassed > todaysDate) {
                isValid = false;
                this.dateCardLostStolenCont.classList.add("form__group--error");
                _dateCardReported.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = dateCardReportedError;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                this.dateReportedCont.appendChild(_errorDiv);
            }
        }
        return isValid;
    };
    FormItemFleetManagementReportLostStolenCard.prototype.validateDeclarationDate = function (value) {
        var selectionArray = [];
        var declarationDateErrorDetails = "Date can\u2019t be in the future.";
        var isValid = true;
        var datePassed = new Date(value);
        var todaysDate = new Date();
        var _declarationDate = this.declarationDate.closest(".form__group");
        selectionArray.push(_declarationDate);
        // Clear errors
        selectionArray.forEach(function (groupItem) {
            groupItem.classList.remove('form__group--error');
            var errorMessage = groupItem.querySelector('.form__group--error_message');
            if (errorMessage) {
                errorMessage.remove();
            }
        });
        if (!_declarationDate.classList.contains("form__group--hidden")) {
            if (datePassed > todaysDate) {
                isValid = false;
                this.declarationDateCont.classList.add("form__group--error");
                _declarationDate.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = declarationDateErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                this.declarationDateCont.appendChild(_errorDiv);
            }
        }
        return isValid;
    };
    FormItemFleetManagementReportLostStolenCard.prototype.updateSuccessEmail = function (pId, split) {
        var _emailAddress = '';
        if (split === "CST") {
            for (var i = 0; i < this.emailAddress.length; i++) {
                if (this.emailAddress[i].name === _emailAddress) {
                    _emailAddress = this.emailAddress[i].email;
                    break;
                }
            }
        }
        else {
            _emailAddress = '';
        }
        var _emailLink = this.element.querySelector("span.js-report-");
        _emailLink.innerHTML = '';
        var _subject = "Documentation for application: ";
        var _body = "To Whom It May Concern\n\nAttached please find a copy of the following documents as requested:\n\n";
        var _mailToText = "mailto:" + _emailAddress + "?subject=" + encodeURIComponent(_subject) + "&body=" + encodeURIComponent(_body);
        var _newButton = document.createElement("a");
        _newButton.textContent = 'EMAIL DOCUMENTS';
        _newButton.setAttribute('style', 'color:white;');
        _newButton.setAttribute("data-id", "link_content_ documents email click");
        _newButton.setAttribute("data-text", "email documents button click");
        _newButton.setAttribute("href", _mailToText);
        _emailLink.appendChild(_newButton);
    };
    FormItemFleetManagementReportLostStolenCard.prototype.closeModal = function () {
        this.analyticsService.dtmFormAbandon();
    };
    FormItemFleetManagementReportLostStolenCard.prototype.validateNewCardRequired = function () {
        var selectionArray = [];
        var radioErrorDetails = "This field is required";
        var isValid = true;
        // Radio Details Selection Error
        var newCardRequiredRadiosGroup = this.newCardRequiredFields[0].closest(".form__group");
        selectionArray.push(newCardRequiredRadiosGroup);
        // Clear errors
        selectionArray.forEach(function (groupItem) {
            groupItem.classList.remove('form__group--error');
            var errorMessage = groupItem.querySelector('.form__group--error_message');
            if (errorMessage) {
                errorMessage.remove();
            }
        });
        // Radio Details Selection Error
        if (!newCardRequiredRadiosGroup.classList.contains("form__group--hidden")) {
            if (this.newCardRequiredVal === "" || this.newCardRequiredVal === undefined) {
                isValid = false;
                newCardRequiredRadiosGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = radioErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                newCardRequiredRadiosGroup.appendChild(_errorDiv);
            }
        }
        return isValid;
    };
    FormItemFleetManagementReportLostStolenCard.prototype.validateOtherItemsLostStolen = function () {
        var selectionArray = [];
        var radioErrorDetails = "This field is required";
        var isValid = true;
        // Radio Details Selection Error
        var otherItemStolenRadioGroup = this.otherItemsLostFields[0].closest(".form__group");
        selectionArray.push(otherItemStolenRadioGroup);
        // Clear errors
        selectionArray.forEach(function (groupItem) {
            groupItem.classList.remove('form__group--error');
            var errorMessage = groupItem.querySelector('.form__group--error_message');
            if (errorMessage) {
                errorMessage.remove();
            }
        });
        // Radio Details Selection Error
        if (!otherItemStolenRadioGroup.classList.contains("form__group--hidden")) {
            if (this.otherItemsLostStolenVal === "" || this.otherItemsLostStolenVal === undefined) {
                isValid = false;
                otherItemStolenRadioGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = radioErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                otherItemStolenRadioGroup.appendChild(_errorDiv);
            }
        }
        return isValid;
    };
    FormItemFleetManagementReportLostStolenCard.prototype.validateCardReported = function () {
        var selectionArray = [];
        var radioErrorDetails = "This field is required";
        var isValid = true;
        // Radio Details Selection Error
        var lossTheftRadioGroup = this.lossTheftReportedFields[0].closest(".form__group");
        selectionArray.push(lossTheftRadioGroup);
        // Clear errors
        selectionArray.forEach(function (groupItem) {
            groupItem.classList.remove('form__group--error');
            var errorMessage = groupItem.querySelector('.form__group--error_message');
            if (errorMessage) {
                errorMessage.remove();
            }
        });
        // Radio Details Selection Error
        if (!lossTheftRadioGroup.classList.contains("form__group--hidden")) {
            if (this.lossTheftReportedVal === "" || this.lossTheftReportedVal === undefined) {
                isValid = false;
                lossTheftRadioGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = radioErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                lossTheftRadioGroup.appendChild(_errorDiv);
            }
        }
        return isValid;
    };
    FormItemFleetManagementReportLostStolenCard.prototype.submitForm = function (form) {
        // success screens
        var loader = form.querySelector('.form__loader--container');
        var thankYou = form.querySelector('.form__thankyou--container');
        var postData = "";
        // additional containers
        var success = form.querySelector('.form__success--container');
        var error = form.querySelector('.form__error--container');
        var name = Array.from(form.querySelectorAll('.form__success-container__firstname'));
        var _initialForm = form.querySelector('.form__fields--container');
        /*
        const _customerNumber: any = form.querySelector('input[name=customer-number]');
        const _customerName: any = form.querySelector('input[name=customer-name]');
        const _registrationNumber: any = form.querySelector('input[name=registration-number]');
        const _vehicleDescription: any = form.querySelector('input[name=vehicle-description]');
        const _lostStolenCardNumber: any = form.querySelector('input[name=lost-stolen-card-number]');
        const _personName: any = form.querySelector('input[name=person-name]');
        const _businessAddress: any = form.querySelector('input[name=business-address]');
        const _residentialAddress: any = form.querySelector('input[name=residential-address]');
        const _workTelNumber: any = form.querySelector('input[name=work-tel-number]');
        const _homeTelNumber: any = form.querySelector('input[name=home-tel-number]');
        const _dateCardLost: any = form.querySelector('input[name=date-card-lost-stolen]');

        const _howCardLost: any = form.querySelector('input[name=where-loss-theft-occured]');
        const _newCardRequired: any = form.querySelector('input[name=new-card-required]');
        const _otherItemsLost: any = form.querySelector('input[name=other-items-lost-stolen]');
        const _reportingCustomerName: any = form.querySelector('input[name=reporting-customer-name]');
        const _hasTheftBeenReported: any = form.querySelector('input[name=has-theft-reported]');
        const _dateReported: any = form.querySelector('input[name=date-reported]');
        
        const _nameOfPoliceStation: any = form.querySelector('input[name=name-of-police-station]');
        const _caseNumnber: any = form.querySelector('input[name=case-number]');
        const _declarationName: any = form.querySelector('input[name=declaration-name]');
        const _declarationTime: any = form.querySelector('select[name=declaration-time]');
        let newTime = Date.now();
        const _declarationDate: any = form.querySelector('input[name=declaration-date]');
        


         const _declarationDA1: any = form.querySelector('input[name=declaration-da1]');
        const _declarationDA2: any = form.querySelector('input[name=declaration-da2]');
        const _declarationDA3: any = form.querySelector('input[name=declaration-da3]'); */
        var serviceType = form.querySelector("input[name=serviceType]");
        if (serviceType) {
            postData += "service-type=" + serviceType.value;
        }
        var product = form.querySelector("input[name=product]");
        if (product) {
            postData += "&product=" + product.value;
        }
        var email = form.querySelector("input[name=email]");
        if (email) {
            postData += "&email=" + email.value;
        }
        var recipient = form.querySelector("input[name=recipient]");
        if (recipient) {
            postData += "&recipient=" + recipient.value;
        }
        var subject = form.querySelector("input[name=subject]");
        if (subject) {
            postData += "&subject=" + subject.value;
        }
        var description = form.querySelector("input[name=description]");
        if (description) {
            postData += "&description=" + description.value;
        }
        var redirect = form.querySelector("input[name=redirect]");
        if (redirect) {
            postData += "&redirect=" + redirect.value;
        }
        var customerNumber = form.querySelector("input[name=customer-number]");
        if (customerNumber) {
            postData += "&customerNumber=" + customerNumber.value;
        }
        var _customerName = this.form.querySelector('input[name=customer-name]');
        if (_customerName) {
            postData += "&customerName=" + _customerName.value;
        }
        var _registrationNumber = this.form.querySelector("input[name=registration-number]");
        if (_registrationNumber) {
            postData += "&registrationNumber=" + _registrationNumber.value;
        }
        var _vehicleDescription = this.form.querySelector("input[name=vehicle-description]");
        if (_vehicleDescription) {
            postData += "&vehicleDescription=" + _vehicleDescription.value;
        }
        var _lostStolenCardNumber = form.querySelector("input[name=lost-stolen-card-number]");
        if (_lostStolenCardNumber) {
            postData += "&lostStolenCardNumber=" + _lostStolenCardNumber.value;
        }
        var _personName = this.form.querySelector("input[name=person-name]");
        if (_personName) {
            postData += "&personName=" + _personName.value;
        }
        var _businessAddress = this.form.querySelector("input[name=business-address]");
        if (_businessAddress) {
            postData += "&businessAddress=" + _businessAddress.value;
        }
        var _residentialAddress = this.form.querySelector("input[name=residential-address]");
        if (_residentialAddress) {
            postData += "&residentialAddress=" + _residentialAddress.value;
        }
        var _workTelNumber = this.form.querySelector("input[name=work-tel-number]");
        if (_workTelNumber) {
            postData += "&workTelNumber=" + _workTelNumber.value;
        }
        var _homeTelNumber = this.form.querySelector("input[name=home-tel-number]");
        if (_homeTelNumber) {
            postData += "&homeTelNumber=" + _homeTelNumber.value;
        }
        var _dateCardLost = this.form.querySelector("input[name=date-card-lost-stolen]");
        if (_dateCardLost) {
            postData += "&dateCardLost=" + _dateCardLost.value;
        }
        var dateParts = _dateCardLost.value.split('/');
        var newDate = '';
        if (dateParts.length > 0 && dateParts.length <= 3) {
            newDate = dateParts[2] + '/' + dateParts[1] + '/' + dateParts[0];
        }
        var _howCardLost = this.form.querySelector("input[name=where-loss-theft-occured]");
        if (_howCardLost) {
            postData += "&howCardLost=" + _howCardLost.value;
        }
        var _newCardRequired = this.form.querySelector("input[name=new-card-required]");
        if (_newCardRequired) {
            postData += "&newCardRequired=" + this.newCardRequired;
        }
        var _otherItemsLost = this.form.querySelector("input[name=other-items-lost-stolen]");
        if (_otherItemsLost) {
            postData += "&otherItemsLost=" + this.anyItemLostStolen;
        }
        var _itemsLostStolen = this.form.querySelector("input[name=items-lost-stolen]");
        if (_itemsLostStolen) {
            postData += "&itemsLostStolen=" + _itemsLostStolen.value;
        }
        var _hasTheftBeenReported = this.form.querySelector("input[name=has-loss-theft-reported]");
        if (_hasTheftBeenReported) {
            postData += "&hasTheftBeenReported=" + this.hasTheftLossReported;
        }
        var _dateReported = this.form.querySelector("input[name=date-reported]");
        if (_dateReported) {
            postData += "&dateReported=" + _dateReported.value;
        }
        var dateParts2 = _dateReported.value.split('/');
        var newDate2 = '';
        if (dateParts2.length > 0 && dateParts2.length <= 3) {
            newDate2 = dateParts2[2] + '/' + dateParts2[1] + '/' + dateParts2[0];
        }
        var _nameOfPoliceStation = this.form.querySelector("input[name=name-of-police-station]");
        if (_nameOfPoliceStation) {
            postData += "&nameOfPoliceStation=" + _nameOfPoliceStation.value;
        }
        var _caseNumber = this.form.querySelector("input[name=case-number]");
        if (_caseNumber) {
            postData += "&caseNumber=" + _caseNumber.value;
        }
        var _declarationName = this.form.querySelector("input[name=declaration-name]");
        if (_declarationName) {
            postData += "&declarationName=" + _declarationName.value;
        }
        var _declarationTime = this.form.querySelector('select[name=declaration-time]');
        if (_declarationTime) {
            postData += "&declarationTime=" + _declarationTime.value;
        }
        var _declarationDate = this.form.querySelector("input[name=case-number]");
        if (_declarationDate) {
            postData += "&declarationDate=" + _declarationDate.value;
        }
        var dateParts3 = _declarationDate.value.split('/');
        var newDate3 = '';
        if (dateParts3.length > 0 && dateParts3.length <= 3) {
            newDate3 = dateParts3[2] + '/' + dateParts3[1] + '/' + dateParts3[0];
        }
        var _declarationDA1 = this.form.querySelector("input[name=declaration-da1]");
        if (_declarationDA1) {
            postData += "&declarationDA1=" + _declarationDA1.value;
        }
        var _declarationDA2 = this.form.querySelector("input[name=declaration-da2]");
        if (_declarationDA2) {
            postData += "&declarationDA2=" + _declarationDA2.value;
        }
        var _declarationDA3 = this.form.querySelector("input[name=declaration-da3]");
        if (_declarationDA3) {
            postData += "&declarationDA3=" + _declarationDA3.value;
        }
        // loader + hide form
        loader.classList.add('active');
        _initialForm.classList.add('hidden');
        _initialForm.classList.remove('active');
        var emailPostData = '';
        /* const _postData = {
            
            'customerNumber':((_customerNumber) ? _customerNumber.value: ``),
            'customerName':((_customerName) ? _customerName.value: ``),
            'registrationNumber': ((_registrationNumber) ? _registrationNumber.value: ``),
            'vehicleDescription': ((_vehicleDescription) ? _vehicleDescription.value: ``),
            'lostStolenCardNumber': ((_lostStolenCardNumber) ? _lostStolenCardNumber.value: ``),
            'name': ((_personName) ? _personName.value: ``),
            'businessAddress' : ((_businessAddress) ? _businessAddress.value: ``),
            'residentialAddress': ((_residentialAddress) ? _residentialAddress.value: ``),
            'workTelNumber': ((_workTelNumber )? _workTelNumber.value: ``),
            'homeTelNumbner': ((_homeTelNumber) ? _homeTelNumber.value: ``),
            'dateCardLost': newDate,
            'howWhereCardLost': ((_howCardLost) ? _howCardLost.value: ``),
            'newCardRequired': ((_newCardRequired) ? _newCardRequired.value: ``),
            'otherItemsLost': ((_otherItemsLost) ? _otherItemsLost.value: ``),
            'reportingCustomerName':((_reportingCustomerName) ? _reportingCustomerName.value: ``),
            'hasTheftBeenReported': ((_hasTheftBeenReported) ? _hasTheftBeenReported.value: ``),

            'dateReported': newDate2,
            'nameOfPoliceStation': ((_nameOfPoliceStation) ? _nameOfPoliceStation.value: ``),
            'caseNumber': ((_caseNumnber) ? _caseNumnber.value: ``),
            //'service-type': this.servicetype,
            'declarationName': ((_declarationName) ? _declarationName.value: ``),
            'declarationTime': ((_declarationTime) ? _declarationTime.value: ``),
            'declarationDate': newDate3,
            'declarationDA1': ((_declarationDA1) ? _declarationDA1.value: ``),
            'declarationDA2': ((_declarationDA2) ? _declarationDA2.value: ``),
            'declarationDA3': ((_declarationDA3) ? _declarationDA3.value: ``)
        }; */
        var _analyticsFlag = document.querySelector(".splitFlag");
        var _split = (_analyticsFlag ? 'CST' : "DFC");
        emailPostData += "splitFlag=" + (_analyticsFlag ? 'CST' : "DFC");
        if (name) {
            name.map(function (_item) {
                // _item.innerHTML = _notifierFirstName.value;
            });
        }
        // variables
        var analyticsService = new AnalyticsService();
        var url = this.baseUrl + "/services/genericform.jsp";
        //JSON.stringify(_postData);
        // service
        this.formsService.postForm(url, postData).then(function (pResponse) {
            loader.classList.remove('active');
            // Always show success message / no response from server (sending email)
            analyticsService.dtmFormComplete('complete', pResponse.code);
            thankYou.classList.add('active');
            error.classList.remove('active');
            error.classList.add('hidden');
            success.classList.remove('hidden');
            success.classList.add('active');
        }).catch(function (pError) {
            // service failed
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            loader.classList.remove('active');
            _initialForm.classList.remove('hidden');
        });
    };
    return FormItemFleetManagementReportLostStolenCard;
}(Base));
export { FormItemFleetManagementReportLostStolenCard };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-fleet-management-report-lost-stolen-card/form-item-fleet-management-report-lost-stolen-card.component.ts
// module id = 892
// module chunks = 0